import { createStore, applyMiddleware, compose } from "redux";
import {
  createStateSyncMiddleware,
  initStateWithPrevTab,
} from "redux-state-sync";
import ReduxThunk from "redux-thunk";
import reducer from "./reducers";
import persistenceMiddleware from "../persistence/middleware/persistenceMiddleware";

const config = {
  // TOGGLE_TODO will not be triggered in other tabs
  channel: "video_data",
  // Blacklist persistence-internal action types to prevent them being
  // broadcast to other tabs via redux-state-sync.
  blacklist: ["TOGGLE_TODO"],
};

// Middleware order matters:
//   1. ReduxThunk        — resolves thunks before persistence sees them
//   2. persistenceMiddleware — intercepts SET_FULL_ANALYSE_STRING for local save
//   3. createStateSyncMiddleware — broadcasts to other tabs AFTER persistence
//
// persistenceMiddleware must come BEFORE createStateSyncMiddleware so that
// the primary tab writes to IndexedDB before the action is replayed in other
// tabs (where the tab-lock guard will correctly no-op the write).
const middlewares = [
  ReduxThunk,
  persistenceMiddleware,
  createStateSyncMiddleware(config),
];

const store = createStore(
  reducer,
  {}, // default state of the application
  compose(applyMiddleware(...middlewares))
);
initStateWithPrevTab(store);
// initMessageListener(store);

export default store;
